import { createAPI } from '@/request.js'

// 代理列表
export const list = data => createAPI('/api/agent/query.mt', 'post', data)
export const agentNameList = data => createAPI('/api/agent/query-name.mt', 'post', data)
// 修改手机号码
export const cellphone = data => createAPI('/api/agent/cellphone/modify.mt', 'post', data)
// 手机号码修改记录
export const cellphoneList = data => createAPI('/api/agent/cellphone/modify/log.mt', 'post', data)
// 获取推荐人
export const referee = data => createAPI('/api/agent/referee/get.mt', 'post', data)
// 修改推荐关系
export const editReferee = data => createAPI('/api/agent/referee/modify.mt', 'post', data)
// 推荐人修改记录
export const refereeList = data => createAPI('/api/agent/referee/modify/log.mt', 'post', data)
// 调整代理分润
export const profit = data => createAPI('/api/agent/profit/modify.mt', 'post', data)
// 收益比例变更记录
export const profitList = data => createAPI('/api/agent/profit/modify/log.mt', 'post', data)
// 分润范围
export const profitRange = data => createAPI('/api/sub/agent/profit/get.mt', 'post', data)
// 开通代理
export const addProxy = data => createAPI('/api/agent/register.mt', 'post', data)
// 修改昵称
export const nickname = data => createAPI('/api/agent/nickname/modify.mt', 'post', data)
export const modifyLevel = data => createAPI('/api/agent/level/modify.mt', 'post', data)
export const modifyPermission = data => createAPI('/api/agent/permission/modify.mt', 'post', data)

// 钱包
export const wallet = data => createAPI('/api/agent/wallet/get.mt', 'post', data)
// 商家周收益
export const week = data => createAPI('/api/agent/week/profit.mt', 'post', data)
// 收益明细
export const statement = data => createAPI('/api/agent/statement/query.mt', 'post', data)
// 明细导出
export const excel = data => createAPI('/download/agent/statement/excel', 'get', data)
// 解除认证
export const cancelCredit = data => createAPI('/api/agent/credit/cancel.mt', 'post', data)
// 确认认证
export const confirmCredit = data => createAPI('/api/agent/credit/confirm.mt', 'post', data)
// 认证记录
export const creditList = data => createAPI('/api/agent/credit/modify/log.mt', 'post', data)
// 调整提现规则
export const withdraw = data => createAPI('/api/agent/withdraw/modify.mt', 'post', data)

// 查询代理
export const agentList = data => createAPI('/api/sub/agent/query.mt', 'post', data)
